"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var responsive_1 = require("@dynamynd/responsive");

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

exports.TitleStyled = styled_components_1.default(components_lib_1.Title)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: ", ";\n    max-width: ", ";\n"], ["\n    margin: ", ";\n    max-width: ", ";\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  return setTitleMargin(activeBreakpoint);
}, function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  return setTitleMaxWidth(activeBreakpoint);
});

function setTitleMargin(activeBreakpoint) {
  if (responsive_1.isSmall(activeBreakpoint)) {
    return '34px 0 14px 0';
  }

  return '70px 0 20px 0';
}

function setTitleMaxWidth(activeBreakpoint) {
  if (responsive_1.isSmallOrMedium(activeBreakpoint)) {
    return '390px';
  }

  return 'auto';
}

exports.TitleAccentText = styled_components_1.default(react_native_1.Text)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n"], ["\n    color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.purple;
});
exports.ButtonSpacer = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  var extraLarge = responsive_1.isExtraLarge(activeBreakpoint);
  return "\n            margin-right: " + (!extraLarge ? 0 : 36) + "px;\n            margin-bottom: " + (!extraLarge ? 14 : 0) + "px;\n        ";
});
exports.ButtonsRow = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      height = _a.height,
      rest = __rest(_a, ["activeBreakpoint", "height"]);

  return react_1.default.createElement(components_lib_1.RowCentered, __assign({}, rest));
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      height = _a.height;
  var extraLarge = responsive_1.isExtraLarge(activeBreakpoint);
  var small = responsive_1.isSmall(activeBreakpoint);
  return "\n        flex-direction: " + (!extraLarge && !small ? 'column' : 'row') + ";\n        margin-top: " + (!extraLarge ? small && height < 640 ? 0 : 16 : 80) + "px;\n        margin-bottom: " + (small ? 16 : 0) + "px;\n        margin-left: " + (small ? -20 : 0) + "px;\n        " + (small ? 'align-items: baseline;' : '') + "\n        ";
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;